import { motion } from "framer-motion";
import React from "react";

const movement = {
  start: { y: 0 },
  animated: {
    y: -5,
    transition: {
      yoyo: Infinity,
      repeatDelay: 0.4,
      duration: 0.3,
      type: "tween",
      easing: "anticipate",
    },
  },
};

const LoadingDots = () => {
  return (
    <span className="inline-block [&_span]:inline-block">
      <motion.span variants={movement}>.</motion.span>
      <motion.span variants={movement}>.</motion.span>
      <motion.span variants={movement}>.</motion.span>
    </span>
  );
};

export default LoadingDots;
